import React from 'react';
import { Inline } from '@atlaskit/primitives/compiled';
import type { EntryPointActions } from '@atlassian/jira-entry-point/src/controllers/utils/types.tsx';
import { CellHoverProvider } from '@atlassian/jira-hover-popover/src/controllers/index.tsx';
import ShowMorePopup, { type Props as PopupProps } from './show-more-popup/index.tsx';

export type Props = {
	/**
	 * The component with the first item to be rendered before the popup
	 */
	ItemComponent: React.JSX.Element | undefined;
	entryPointActions?: EntryPointActions;
} & PopupProps;

const ItemWithPopup = ({
	ItemComponent,
	showMoreTooltip,
	totalItems,
	PopupComponent,
	isOpen,
	onSetIsOpen,
	triggerRefCallback,
	actionSubjectIdPrefix,
	isTruncated = false,
	entryPointActions,
}: Props) => {
	if (ItemComponent === undefined) {
		return null;
	}

	return (
		<Inline space="space.100" alignBlock="center" shouldWrap={!isTruncated}>
			{ItemComponent}
			{totalItems > 1 && (
				<CellHoverProvider>
					<ShowMorePopup
						showMoreTooltip={showMoreTooltip}
						totalItems={totalItems - 1}
						PopupComponent={PopupComponent}
						isOpen={isOpen}
						onSetIsOpen={onSetIsOpen}
						triggerRefCallback={triggerRefCallback}
						actionSubjectIdPrefix={actionSubjectIdPrefix}
						isTruncated={isTruncated}
						entryPointActions={entryPointActions}
					/>
				</CellHoverProvider>
			)}
		</Inline>
	);
};

export default ItemWithPopup;
